export function createLocalStorageOnce<T = any>(key: string) {
  return {
    setValue: (value: T): void => {
      try {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
      } catch (error) {
        console.error(`Error setting localStorage key "${key}":`, error);
      }
    },

    getValue: (): T | null => {
      try {
        const item = localStorage.getItem(key);
        if (item === null) {
          return null;
        }
        return JSON.parse(item) as T;
      } catch (error) {
        console.error(`Error getting localStorage key "${key}":`, error);
        return null;
      }
    },

    destroyValue: (): void => {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.error(`Error removing localStorage key "${key}":`, error);
      }
    },

    getValueOnce: (): T | null => {
      try {
        const item = localStorage.getItem(key);
        if (item === null) {
          return null;
        }
        localStorage.removeItem(key);
        return JSON.parse(item) as T;
      } catch (error) {
        try {
          localStorage.removeItem(key);
        } catch (removeError) {
          console.error(
            `Error removing localStorage key "${key}" after failed parse:`,
            removeError
          );
        }
        return null;
      }
    },
  };
}
